var toastId = 1;
var timerAlert = null;
/**
 * int ORDER BY part array position
 */
const OPTION_ORDER = 1;
/**
 * int LIMIT part array position
 */
const OPTION_LIMIT = 2;
/**
 * int OFFSET part array position
 */
const OPTION_OFFSET = 3;
/**
 * int GROUP BY part array position
 */
const OPTION_GROUP = 4;

window.OPTION_ORDER = OPTION_ORDER;
window.OPTION_LIMIT = OPTION_LIMIT;
window.OPTION_OFFSET = OPTION_OFFSET;
window.OPTION_GROUP = OPTION_GROUP;
/**
 * Browser-side cache namespace
 */
UtilCache = {
    /**
     * hashlist cache entries
     */
    _cache: [],
    /**
     * Set element to cache.
     *
     * @param[in] key string Cache key.
     * @param[in] item object Cache object.
     */
    set: function(key, item) {
        this._cache[key] = item;
    },
    /**
     * Get element from cache.
     *
     * @param[in] key string Cache key.
     * @return object Cache object or null if does not exists.
     */
    get: function(key) {
        return this.hasElement(key) ? this._cache[key] : null;
    },

    /**
     * Delete element from cache.
     *
     * @param[in] key string Cache key.
     */
    deleteCache: function(key) {
        if (this.hasElement(key)) {
            delete this._cache[key];
        }
    },
    /**
     * Check if has element in cache.
     *
     * @param[in] key string Cache key.
     * @return boolean True if has.
     */
    hasElement: function(key) {
        return this._cache[key] ? true : false;
    },
};

/**
 * util global namespace
 */
Util = {
    /**
     * hashlist Services proxy cache.
     */
    _services: {},
    /**
     * function On load callbacks.
     */
    _onloadcallbacks: [],
    /**
     * utilCache cache package.
     */
    cache: UtilCache,

    /**
     * JSON-RPC service sub-system
     *
     * Initialize the JSON-RPC proxy with some service. The proxy is cached
     * in the Util._services hashlist to avoid double initialization.
     *
     * @param[in] serviceName string The service name.
     * @return object JavaScript object proxy.
     */
    service: function(serviceName, async, options) {
        if (!Util.cache.hasElement("serviceApiLoaded")) {
            Util.cache.set("serviceApiLoaded", true);
        }
        
        var optionsHash = hashCode(JSON.stringify(options));
        var cacheKey = serviceName + async + optionsHash;

        if (!Util._services[cacheKey] || 1) {
            if (typeof lang == "undefined") {
                lang = $("html")
                    .attr("lang")
                    .replace("-", "_");
            } else {
                //					var lang = lang.toLowerCase();
            }
            if (typeof tv != 'undefined' && tv)
            {                    
                var qTv = '&TV=1&PBSHOP='+portobelloShop+'&REVENDA='+revenda;
            }
            else
            {
                var qTv = '';
            }
            options = $.extend(
                {
                   
                    url: serviceName.indexOf("http") >= 0 ? serviceName : "/rpc/json/" + serviceName + "?lang=" + lang + qTv,
                    exceptionHandler: Util.serviceException,
                    preProcessing: Util.preProcessParams,
                    postProcessing: Util.postProcessResult,
                    headers: {
                        //	"X-util-Oid": oid
                        //	"Content-Type": "application/json; charset=ISO-8859-1"
                    },
                },
                options
            );

            if (async) {
                options.async = true;
                options.asyncReflect = true;
            }

            transport = GI.jsonrpc(options);

            if (transport.error) {
                console.warn("Transport endpoint initialization error for service %s.\n%o.", serviceName, transport);
                //alert( _t( "GLOBAL_ESERVICEENDPOINTERROR", [ serviceName, transport.error_request.status, transport.error_request.statusText ] ) );
                return null;
            } else {
                Util._services[cacheKey] = transport;
            }
        } else {
            if (async) {
                options.reflectSuccess(Util._services[cacheKey]);
            }
        }

        return Util._services[cacheKey];
    },
    /**
     * Function to check if the param is set.
     */
    isDefined: function(data) {
        if (data == "undefined" || typeof data == "undefined" || data == null) {
            return false;
        }
        return true;
    },
    /**
     * Service exception handler.
     *
     * This function will open a modal window with the exception error.
     *
     * @param[in] exception exception exception object.
     */
    serviceException: function(exception) {
        console.log(exception);
        UtilUi.alert(exception.message);
        throw new Error(exception);
    },
    /**
     * Add callback to onload event.
     *
     * @param[in] callback function Callback.
     */
    addonload: function(callback) {
        this._onloadcallbacks.push(callback);
    },
    /**
     * Onload event.
     *
     * This event is fired when the page is fully loaded.
     */
    onload: function() {
        //console.log('Onload do Framework...');
        for (var i = 0; i < Util._onloadcallbacks.length; i++) {
            Util._onloadcallbacks[i]();
        }
    },
    /**
     * Complete html load event.
     *
     * This event is fired when the page is fully loaded.
     */
    complete: function() {},
    /**
     * Convert Entitys to JS types
     */
    postProcessResult: function(input) {
        var output = input;
        array_walk_recursive(output, "convertTypesOut", "userdata");
        return output;
    },
    /**
     * Convert Entitys to JS types
     */
    preProcessParams: function(input) {
        var output = clone(input);
        array_walk_recursive(output, "convertTypesIn", "userdata");
        return output;
    },
    includeCss: function(url) {
        var css = $("<link>");
        css.attr({
            rel: "stylesheet",
            type: "text/css",
            href: url,
        });
        $("head").append(css);
        css = null;
        return true;
    },
    includeJavascript: function(url, callBack, callBackError) {
        var successflag = false;
        if (url) {
            if (!Util.cache.hasElement(url)) {
                jQuery.ajax({
                    async: false,
                    type: "GET",
                    url: url,
                    dataType: "script",
                    data: null,
                    success: function(data, status, xhr) {
                        successflag = true;

                        if (callBack) {
                            callBack();
                        }
                    },
                    error: function(xhr, status, error) {
                        if (callBackError) {
                            console.error(status);
                            console.error(error);
                            callBackError();
                        }
                    },
                });
                Util.cache.set(url, true);
            } else {
                successflag = true;
                if (callBack) {
                    callBack();
                }
            }
        }
        return successflag;
    },

    getCookie: function(name) {
        var start = document.cookie.indexOf(name + "=");
        var len = start + name.length + 1;
        if (!start && name != document.cookie.substring(0, name.length)) return null;
        if (start == -1) return null;
        var end = document.cookie.indexOf(";", len);
        if (end == -1) end = document.cookie.length;
        return unescape(document.cookie.substring(len, end));
    },
    setCookie: function(name, value, expires, path, domain, secure) {
        document.cookie =
            name +
            "=" +
            escape(value) +
            (expires > 0 ? ";expires=" + expires.toGMTString() : "") +
            (path ? ";path=" + path : "") +
            (domain ? ";domain=" + domain : "") +
            (secure ? ";secure" : "");
    },
    deleteCookie: function(name, path, domain, secure) {
        document.cookie =
            name +
            "=" +
            ";expires=Thu, 01 Jan 1970 00:00:00 UTC" +
            (path ? ";path="+ path : "") +
            (domain ? ";domain=" + domain : "") +
            (secure ? ";secure" : "");
    },

    //Update CKEditor Inputs before submit updated values
    CKEditorUpdateFields: function() {
        return new Promise(function(resolve, reject) {
            var bodyElement = document.querySelector('body');
            var textareaElement = document.querySelectorAll('textarea');
            var ckeButtons = document.querySelectorAll('a.cke_button.cke_button__source.cke_button_on');
            ckeButtons.forEach(function(btn) {
                btn.click();
            });
            textareaElement.forEach(function(textarea) {
                textarea.blur();
            });
            bodyElement.click();
            bodyElement.focus();
            bodyElement.click();
            bodyElement.focus();
            resolve();
        });
    },

    //Update CKEditor Inputs before submit updated values
    CKEditorUpdateModalFields: function() {
        return new Promise(function(resolve, reject) {
            var modalBodyElement = document.querySelector('.modal-body');
            var textareaElement = document.querySelectorAll('textarea');
            var ckeButtons = document.querySelectorAll('a.cke_button.cke_button__source.cke_button_on');
            ckeButtons.forEach(function(btn) {
                btn.click();
            });
            textareaElement.forEach(function(textarea) {
                textarea.blur();
            });
            modalBodyElement.click();
            modalBodyElement.focus();
            modalBodyElement.click();
            modalBodyElement.focus();
            resolve();
        });
    },
};

UtilUi = {
    // inicializações
    /**
	 * boolean Check if client translate file is loaded
	 */
    _clientTranslateLoaded: false,
    /**
	 * string Messages translations
	 */
	messages: {},

    initializeJSmart: function() {
        jSmart.prototype.getTemplate = function(name) {
            var nameOri = name;
            name = basename(name);
            if (name.indexOf(".") >= 0) {
                fl = name.substring(0, 1).toUpperCase();
                name = name.substring(1, name.indexOf("."));

                tplName = "tpl" + fl + name;
            } else {
                tplName = name;
            }

            function loadTemplate(tplName, original) {
                var tpl = $("#" + tplName);
                if (tpl.length > 0) {
                    return tpl.html();
                } else {
                    var result = UtilUi.loadTemplate(original.replace("../", "").replace("../../", "").replace("../../../", ""), null, null, true);
                    return $("#" + tplName).html();
                }
            }

            return loadTemplate(tplName.trim(), nameOri);
        };

        jSmart.prototype.registerPlugin("function", "secondsToTime", function(params, data) {
            var s = "";
            if ("from" in params) {
                result = secondsToTime(params["from"]);
                s = result["h"] + "h:" + result["m"] + "m:" + result["s"] + "s";
            }
            return s;
        });

        jSmart.prototype.registerPlugin("function", "_t", function(params, data) {
            if ("id" in params) return _t(params["id"]);
            return params["id"];
        });

        jSmart.prototype.registerPlugin("block", "_t", function(params, content, data, repeat) {
            return _t(content);
        });

        /**
         * @TODO Verificar de alguma maneira se o script que esta \
         * tentando carregar já não foi inserido por outro tpl jSmart\
         * ou pela propria aplicação.
         */
        jSmart.prototype.registerPlugin("function", "addJs", function(params, data) {
            if ("file" in params) {
                var str = params["file"];
                if (str.substr(0, 1) == "/" || str.substr(0, 4) == "http") str = params["file"];
                else str = "/include/js/" + params["file"];
                Util.includeJavascript(str);
            }
            return "";
        });

        /**
         * @TODO Verificar caminhos dos CSS para incluir das pastas corretas de acordo
         * com a regra padrão definida no método 'displayCss' do 'Template.php'
         */
        jSmart.prototype.registerPlugin("function", "addCss", function(params, data) {
            if ("file" in params) {
                if (params["file"][0] == "/") {
                    var str = params["file"];
                }
                Util.includeCss(str);
                str = null;
            }
            return "";
        });

        jSmart.prototype.registerPlugin("modifier", "slug", UtilUi.slug);

        jSmart.prototype.registerPlugin("modifier", "number_format",  function (number, decimals, decPoint, thousandsSep) {
            // eslint-disable-line camelcase
            //  discuss at: http://locutus.io/php/number_format/
            // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
            // improved by: Kevin van Zonneveld (http://kvz.io)
            // improved by: davook
            // improved by: Brett Zamir (http://brett-zamir.me)
            // improved by: Brett Zamir (http://brett-zamir.me)
            // improved by: Theriault (https://github.com/Theriault)
            // improved by: Kevin van Zonneveld (http://kvz.io)
            // bugfixed by: Michael White (http://getsprink.com)
            // bugfixed by: Benjamin Lupton
            // bugfixed by: Allan Jensen (http://www.winternet.no)
            // bugfixed by: Howard Yeend
            // bugfixed by: Diogo Resende
            // bugfixed by: Rival
            // bugfixed by: Brett Zamir (http://brett-zamir.me)
            //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
            //  revised by: Luke Smith (http://lucassmith.name)
            //    input by: Kheang Hok Chin (http://www.distantia.ca/)
            //    input by: Jay Klehr
            //    input by: Amir Habibi (http://www.residence-mixte.com/)
            //    input by: Amirouche
            //   example 1: number_format(1234.56)
            //   returns 1: '1,235'
            //   example 2: number_format(1234.56, 2, ',', ' ')
            //   returns 2: '1 234,56'
            //   example 3: number_format(1234.5678, 2, '.', '')
            //   returns 3: '1234.57'
            //   example 4: number_format(67, 2, ',', '.')
            //   returns 4: '67,00'
            //   example 5: number_format(1000)
            //   returns 5: '1,000'
            //   example 6: number_format(67.311, 2)
            //   returns 6: '67.31'
            //   example 7: number_format(1000.55, 1)
            //   returns 7: '1,000.6'
            //   example 8: number_format(67000, 5, ',', '.')
            //   returns 8: '67.000,00000'
            //   example 9: number_format(0.9, 0)
            //   returns 9: '1'
            //  example 10: number_format('1.20', 2)
            //  returns 10: '1.20'
            //  example 11: number_format('1.20', 4)
            //  returns 11: '1.2000'
            //  example 12: number_format('1.2000', 3)
            //  returns 12: '1.200'
            //  example 13: number_format('1 000,50', 2, '.', ' ')
            //  returns 13: '100 050.00'
            //  example 14: number_format(1e-8, 8, '.', '')
            //  returns 14: '0.00000001'
        
            number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
            var n = !isFinite(+number) ? 0 : +number;
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
            var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
            var dec = typeof decPoint === "undefined" ? "." : decPoint;
            var s = "";
        
            var toFixedFix = function(n, prec) {
                if (("" + n).indexOf("e") === -1) {
                    return +(Math.round(n + "e+" + prec) + "e-" + prec);
                } else {
                    var arr = ("" + n).split("e");
                    var sig = "";
                    if (+arr[1] + prec > 0) {
                        sig = "+";
                    }
                    return (+(
                        Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) +
                        "e-" +
                        prec
                    )).toFixed(prec);
                }
            };
        
            // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || "").length < prec) {
                s[1] = s[1] || "";
                s[1] += new Array(prec - s[1].length + 1).join("0");
            }
        
            return s.join(dec);
        });
        

        jSmart.prototype.registerPlugin("modifier", "capitalizeGrupos", function(str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                if (splitStr[i].length > 2 || i == 0)
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            // Directly return the joined string
            return splitStr.join(' '); 
            //return str.replace(/(^|\s)\S/g, (l) => l.toUpperCase());
        });
    },
    /**
     * Add invalid class to a field.
     * @param[in] inputTarget ID from input.
     */
    displayFieldInvalid: function(inputTarget) {
        $(inputTarget)
            .parent("label")
            .addClass("invalid");
    },
    /**
     * Remove invalid class to a field.
     * @param[in] inputTarget ID from input.
     */
    dismissFieldInvalid: function(inputTarget) {
        const label = $(inputTarget).parent("label");

        if ($(inputTarget).val() !== "" && label.hasClass("invalid")) {
            label.removeClass("invalid");
        }
    },
    /**
     * Load Jsmart templates
     * @param[in] template string
     * @param[in] callBack string
     * @param[in] data array
     */
    loadTemplate: function(template, callBack, data, sync, langLocal) {
        var result = "";
        var templateName = basename(template);
        var templateID =
            "tpl" +
            templateName
                .replace(".tpl", "")
                .substring(templateName.indexOf("/") + 1)
                .capitalizeFirstLetter();
        var single = template.indexOf(".tpl") > 0 ? true : false;

        if (!Util.cache.hasElement("tplS" + templateID)) {
            if ($("#" + templateID).length == 0) {
                var type = "xhtml";

                if (typeof sync != "undefined" && sync) {
                    jQuery.ajaxSetup({ async: false });
                }
                if (langLocal == null)
                {
                    if (typeof lang == "undefined") {
                        var lang = $("html")
                            .attr("lang")
                            .replace("-", "_");
                    } else {
                        //					var lang = lang.toLowerCase();
                    }
                }
                else
                {
                    lang = langLocal.replace("-", "_");
                }
                if (lang == "en") {
                    lang = "en_US";
                }
                if (typeof portobelloshop != "undefined") {
                    //pathTMP = '/portobelloshop';
                    pathTMP = "";
                } else {
                    pathTMP = "";
                }
                //$.get(pathTMP+'/tpl/'+template+'?lang='+lang+'&type='+type, function(template) {
                $.get(pathTMP + "/tpl/" + template + "?lang=" + lang, function(template) {
                    console.log(lang);
                    $("head").append(template);
                    result = template;
                    if (callBack != undefined) {
                        if (single) {
                            var tpl = new jSmart($("#" + templateID).html());
                            Util.cache.set("tplS" + templateID, tpl);
                            callBack(data, tpl);
                        } else {
                            callBack(data);
                        }
                    }
                });
                return result;
            } else {
                if (callBack != undefined) {
                    if (single) {
                        var tpl = new jSmart($("#" + templateID).html());
                        callBack(data, tpl);
                    } else {
                        callBack(data);
                    }
                }
            }
        } else {
            if (callBack != undefined) {
                var tpl = new jSmart($('#'+templateID).html());
                //var tpl = Util.cache.get("tplS" + templateID);
                callBack(data, tpl);
            } else {
                return $("#" + templateID).html();
            }
        }
    },
    /**
     * Oeen modal
     */
    openModal: function(source, timing = "fast") {
        if (typeof source == undefined) {
            return false;
        }

        let target;

        if (source.charAt(0) == "#") {
            target = source;
        } else {
            target = "#" + source;
        }

        $("body").addClass("modal-active");
        $(target).fadeIn(timing);

        return true;
    },
    /*
     * Close modal
     */
    closeModal: function(source) {
        if (typeof source == undefined) {
            return false;
        }

        let target;

        if (source.charAt(0) == "#") {
            target = source;
        } else {
            target = "#" + source;
        }

        $("body").removeClass("modal-active");
        $(target).fadeOut("fast", function() {
            $(this).remove();
        });

        return true;
    },
    /**
     * Set locale to Jsmarty
     */
    setLocale: function(lang) {
        if (typeof lang == "undefined") {
            var lang = $("html")
                .attr("lang")
                .replace("-", "_");
            if (typeof lang != "undefined" && lang) {
                var langEx = lang.split("_");
                if (langEx.length > 1) {
                    lang = langEx[0] + "_" + langEx[1].toUpperCase();
                }
            }
        }
        setlocale("LC_ALL", lang);
    },
    initLazyLoad: function() {
        console.log("lazyLoad init");
        if (typeof IntersectionObserver != "undefined") {
            var lazyLoadImages = function(entries, observer) {
                entries.forEach(function(element, index, array) {
                    if (element.isIntersecting) {
                        var dataSrc = element.target.dataset.src;
                        var src = element.target.attributes.src;

                        if (typeof src == "undefined" || !src) element.target.setAttribute("src", dataSrc);
                    }
                });
            };

            var observer = new IntersectionObserver(lazyLoadImages);

            function logArrayElements(element, index, array) {
                if (element instanceof HTMLImageElement) observer.observe(element);
            }

            var imgElements = $("img[data-src]").not("img[src]");
            Object.values(imgElements).forEach(logArrayElements);
        } else {
            $("img[data-src]")
                .not("img[src]")
                .each(function() {
                    $(this).prop("src", $(this).data("src"));
                });
        }
    },

    alert: function (message, messageType, timeout = 10000, parent = null)
	{
        clearTimeout(timerAlert);
        toastId++;
        let decodedTitle = '';
        let decodedMessage = '';
        if (typeof message == 'string')
        {
            decodedTitle = $.parseHTML(message)[0].textContent;
            decodedMessage = '';
        }
        else if (typeof message == 'object')
        {
            if (typeof message.title != 'undefined')
                decodedTitle = $.parseHTML(message.title)[0].textContent;
            if (typeof message.message != 'undefined')
                decodedMessage = $.parseHTML(message.message)[0].textContent;
        }

        if (typeof messageType == 'undefined') {
            messageType = 'warning';
        }

        if ($('.pb-notification').length >= 5)
        {
            for (var x=1; x<(toastId-5);x++)
            {
                $(`#toast-${x}`).remove();
            }
        }
        if (/* messageType == 'success' */ false) {
            var timeoutAttr = '5s';
        } else if (timeout)
        {
            var timeoutAttr = timeout/1000 + 's';
        }
        var existing = $('.pb-notification.item[data-title="'+decodedTitle+'"]');
        if (existing.filter(':visible').length > 0)
        {
            var total = existing.find('.total').text();
            if (typeof total == 'undefined' || !total)
            {
                total = 0;
            }
            existing.find('.total').text(parseInt(total) + 1);
            existing.find('.total').show();
            toastId = existing.attr('id');
            //$('.pb-notification.item').fadeIn();
        }
        else
        {
            var html = '<div class="pb-notification item" id="toast-'+toastId+'" data-title="'+decodedTitle+'" data-status="'+messageType+'" data-timeout="'+timeoutAttr+'">\
                <div class="notification-container">\
                    <div class="icon">\
                        <img src="/template/images/icons/icon_alert-'+messageType+'.svg">\
                    </div>\
                    <div class="content">\
                        <span class="title">'+decodedTitle+'</span>\
                        <span class="total" style="display:none;"></span>\
                        <span class="message">'+decodedMessage+'</span>\
                    </div>\
                    <div class="action">\
                        <button class="pb-btn-close jsClose">\
                            <span class="icon"></span>\
                        </button>\
                    </div>\
                </div>\
            </div>';				

            if (parent)
            {
                $(parent).prepend(html);
            
            }
            else
            {
                $('body #toast-container').prepend(html);
            }
        }
        if ($('#toast-container .pb-notification.item:visible').length >= 2)
        {
            $('#toast-container .pb-btn.alert').fadeIn();
        }
        $('#toast-container').fadeIn();

        var toastIdElement = '#toast-'+toastId+'.item'; 
        console.log(toastId);
        setTimeout(() => {
            // console.log(toastId);
            // console.log($(toastIdElement));
            $(toastIdElement).fadeOut(function(){
                $(this).remove();
            });
        }, 5000);

        // apagar alertas
        $('#toast-'+toastId+'.item .jsClose').on('click', function(e)
        {
            e.preventDefault();
            $(this).parents('.pb-notification.item').fadeOut(function() {
                $(this).remove();
                if ($('#toast-container .pb-notification.item:visible').length == 0)
                {
                    $('#toast-container .pb-btn.alert').fadeOut();
                }
                
            });
            return false;
        });

        // apagar todos os alertas
        $('.jsClearAllAlerts').on('click',function(e){
            e.preventDefault();
            $('#toast-container .pb-notification.item').fadeOut(function() {
                $(this).remove();
                $('.jsClearAllAlerts').fadeOut();
            });
            return false;
        });

		if (messageType == 'success') {
			setTimeout(function()	 {
				$('#toast-'+toastId).fadeOut(function() {
					$(this).remove();
				});
			}, timeout);

            setTimeout(function()	 {
				$('.jsClearAllAlerts').fadeOut(function() {
					
				});
			}, timeout);
        } else if (messageType == 'error'){
            setTimeout(function()	 {
				$('.jsClearAllAlerts').fadeOut(function() {
					
				});
			}, timeout);
		}else if (messageType == 'warning'){
            setTimeout(function()	 {
				$('.jsClearAllAlerts').fadeOut(function() {
					
				});
			}, timeout);
        }
        timerAlert = setTimeout(function()
        {
            UtilUi.removeAlerts();
        }, 5000);
    },

    removeAlerts: function() {
        $(".toast").fadeOut(function() {
            $(this).remove();
        });
    },
    /**
	 * Load language pack.
	 * 
	 * @param[in] namespace string Namespace name in all upper case.
	 */
	loadLanguage: function( namespace, client )
	{		
		if( namespace ||  namespace == namespace.toUpperCase() )
		{
			if( ! ( namespace in UtilUi.messages ) )
			{ // avoid double load
				var lang = $( "html" ).attr( "lang" ).toLowerCase().replace( '-', '_' );
				if (idClient == 8)
				{
					lang = 'pt_br';
				}
				var url = window.location.protocol + '//' + window.location.host + "/apis/language/" + lang + "/" + namespace.toLowerCase() + ".json";
				if( ! UtilUi._loadLanguage( namespace, url ) && lang != "en" )
				{
					url =  window.location.protocol + '//' + window.location.host +"/apis/language/pt_br/" + namespace.toLowerCase() + ".json";
					UtilUi._loadLanguage( namespace, url );
				}
			}
			else
			{
				console.warn( "Namespace %s already loaded, bailing out.", namespace );
				//console.trace();
			}
		}
		else
		{
			console.error( "Unable to load namespace %s. Namespace should be all upper case.", namespace );
			//console.trace();
		}
		
	},
    /**
	 * Run the language loader call.
	 * 
	 * @param[in] namespace string Namespace being loaded.
	 * @param[in] url string Namespace url.
	 * @return boolean true if was loaded, false otherwise.
	 */
	_loadLanguage: function( namespace, url )
	{
		var _return = false;
		if (!Util.cache.hasElement('translationNotFoud_'+namespace))
		{				
			$.ajax( url, {
				async: false,
				success: function( data, textStatus, jqXHR ) 
				{
					UtilUi.messages[namespace] = data;
					_return = true;
				},
				error: function( data, textStatus, jqXHR ) 
				{
					console.warn( "Unable to initialize or locate namespace %s on URL: %s.", namespace, url );
					// setar cache para n�o cache
					Util.cache.set('translationNotFoud_'+namespace, true);
					_return = false;
					//console.trace();
				},
				dataType: "json"
			} );
			return _return;
		} else {
			console.warn( "Unable to initialize or locate namespace %s on URL: %s.[cached]", namespace, url );
			return false;
		}
	},
    /**
	 * Translate message.
	 * 
	 * @param[in] msgid string Message ID in format NAMESPACE_ID.
	 * @param[in] params array Substitution values.
	 * @param[in] plural array Plural positions.
	 * @return string Translated message.
	 */
	translate: function( msgid, params, plural )
	{
		if( !UtilUi._clientTranslateLoaded )
		{
			UtilUi._clientTranslateLoaded = true;
			UtilUi.loadLanguage( "CLIENT", true );
		}
		if( typeof( params ) == 'undefined' )
		{
			var params = [];
		}
		if( typeof( plural ) == 'undefined' )
		{
			var plural = [];
		}

		var parts = msgid.split( "_" );
		if( parts.length == 2 )
		{
			var namespace = parts[0];
			var _id = parts[1];
			delete parts;
		}
		else
		{ // wrong format
			console.warn( "Message id %s has none or more than one '_' (underscore) character.", msgid );
			//console.trace();
			// return msgid;
			var _id = msgid;
		}

		var cmsgid = msgid;
		// plural versions
		if( plural.length > 0 && params.length > 0 )
		{
			if( plural.length > params.length )
			{
				console.warn( "%s: Plural settings has more positions than substitution parameters, ignoring plural settings.", msgid );
			}
			else
			{
				var pluralsettings = "";
				for( var i = 0; i < plural.length; i++ )
				{
					if( typeof( params[plural[i]-1] ) == 'number' )
					{
						if( params[plural[i]-1] > 1 )
						{
							pluralsettings += 'P';
						}
						else
						{
							pluralsettings += 'S';
						}
					}
					else if( typeof( params[plural[i]-1] ) == 'undefined' )
					{
						console.warn( "%s: Plural setting sequence %d is pointing to an undefined parameter at %d. Using SINGULAR.", msgid, i, plural[i] );
						pluralsettings += 'S';
					}
					else
					{
						console.warn( "%s: Plural setting sequence %d is pointing to an invalid parameter at %d (%s). The paremeter is not a number. Using SINGULAR.", msgid, i, plural[i], params[plural[i]-1] );
						pluralsettings += 'S';
					}
				}
				_id = _id + '.' + pluralsettings;
				cmsgid = msgid + '.' + pluralsettings;
			}
		}
		else if( plural.length > 0 )
		{
			console.warn( "%s: Plural settings was defined but there are no substitution parameters, ignoring plural settings.", msgid );
		}

		var msg = null;
		if( typeof( UtilUi.messages["CLIENT"] ) != 'undefined' && typeof( UtilUi.messages["CLIENT"][cmsgid] ) != 'undefined' )
		{ // first lookup client namespace
			msg = UtilUi.messages["CLIENT"][cmsgid];
		}
		else
		{ // else lookup the default namespace
			// auto loader
			if( typeof( UtilUi.messages[namespace] ) == 'undefined' && namespace)
			{
				UtilUi.loadLanguage( namespace );
			}

			if( typeof( UtilUi.messages[namespace] ) != 'undefined' && typeof( UtilUi.messages[namespace][_id] ) != 'undefined' )
			{
				msg =UtilUi.messages[namespace][_id];
			}
		}

		if( msg != null)
		{
			if( params.length > 0 )
			{
				for( i = 0; i < params.length; i++ )
				{
					var search = "$" + ( i + 1 );
					msg = msg.replace( search, params[i] );
				}
			}
		}
		else
		{
			console.warn( "Missing message id %s.", msgid );
			msg = msgid;
		}
		if (!Util.isDefined(msg))
		{
			msg = msgid;
		}

		return msg;
	}    
};


// ALERTs
var alerts = [];
var idAlert = 1;
alertInterface = {
    alert: function(message, type) {
        //alert(message);
        if (typeof type == 'undefined') {
            type = 'success';
        }
        idAlert++;
        var alertNumber = alerts.push({ id: idAlert, msg: _t(message), type: type });
        setTimeout(function() {
            alerts.splice(alertNumber - 1, 1);
        }, 3000);
    },
    showError: function(exception) {
        console.error(exception);
        //alert(message);
        if (typeof exception.message == 'undefined') {
            var message = exception;
        } else {
            var message = exception.message;
        }
        idAlert++;
        var alertNumber = alerts.push({ id: idAlert, msg: message, type: 'danger' });
        setTimeout(function() {
            alerts.splice(alertNumber - 1, 1);
        }, 5000);
    },
    confirm: function(title, message, yesFunction, noFunction, options) {
        if (confirm(_t(title) + ': ' + _t(message))) {
            yesFunction();
        } else {
            noFunction();
        }
    }
};

alertInterfaceSite = {
    alert: function(message, type) {
        //alert(message);
        if (typeof type == 'undefined') {
            type = 'success';
        }
        idAlert++;
        var alertNumber = alerts.push({ id: idAlert, msg: _t(message), type: type });
        setTimeout(function() {
            alerts.splice(alertNumber - 1, 1);
        }, 3000);
        alert(message);
    },
    showError: function(exception) {
        console.error(exception);
        //alert(message);
        if (typeof exception.message == 'undefined') {
            var message = exception;
        } else {
            var message = exception.message;
        }
        alert(message);
        idAlert++;
        var alertNumber = alerts.push({ id: idAlert, msg: message, type: 'danger' });
        setTimeout(function() {
            alerts.splice(alertNumber - 1, 1);
        }, 5000);
    },
    confirm: function(title, message, yesFunction, noFunction, options) {
        if (confirm(_t(title) + ': ' + _t(message))) {
            yesFunction();
        } else {
            noFunction();
        }
    }
};

function clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}
window.clone = clone;

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

function convertTypesIn(field, key) {
    // numeric
    /**
     * int TINYINT, SMALLINT, MEDIUMINT, INT, BIGINT, BIT data types.
     */
    const TYPE_INTEGER = 1;
    /**
     * int FLOAT, REAL, DOUBLE data types.
     */
    const TYPE_FLOAT = 2;
    /**
     * int DECIMAL, NUMERIC data types.
     */
    const TYPE_DECIMAL = 3;
    // date and time
    /**
     * int DATE data type.
     */
    const TYPE_DATE = 4;
    /**
     * int TIME data type.
     */
    const TYPE_TIME = 5;
    /**
     * int DATETIME data type.
     */
    const TYPE_DATETIME = 6;
    /**
     * int TIMESTAMP data type.
     */
    const TYPE_TIMESTAMP = 7;
    /**
     * int YEAR data type.
     */
    const TYPE_YEAR = 8;
    // string
    /**
     * int CHAR, VARCHAR data types.
     */
    const TYPE_VARCHAR = 9;
    /**
     * int TINYTEXT, SMALLTEXT, MEDIUMTEXT, TEXT, LONGTEXT data types.
     */
    const TYPE_TEXT = 10;
    /**
     * int ENUM data type.
     */
    const TYPE_ENUM = 11;
    /**
     * int SET data type.
     */
    const TYPE_SET = 12;
    // binary
    /**
     * int TINYBLOB, SMALLBLOB, MEDIUMBLOB, BLOB, LONGBLOB data types.
     */
    const TYPE_BLOB = 13;

    if (
        typeof field != "undefined" &&
        field != null &&
        field.hasOwnProperty("__types__") &&
        typeof field.__types__ != "undefined"
    ) {
        for (var fieldTypeIdx in field.__types__) {
            var fieldType = field.__types__[fieldTypeIdx];
            if (typeof field[fieldType.field] != "undefined" && field[fieldType.field] != null) {
                switch (parseInt(fieldType.type)) {
                    case TYPE_INTEGER:
                        field[fieldType.field] = parseInt(field[fieldType.field]);
                        break;
                    case TYPE_FLOAT:
                    case TYPE_DECIMAL:
                        field[fieldType.field] = parseFloat(field[fieldType.field]);
                        break;
                    case TYPE_DATE:
                        if (typeof field[fieldType.field] == "object" && field[fieldType.field]) {
                            field[fieldType.field] =
                                field[fieldType.field].getFullYear() +
                                "-" +
                                ("0" + (field[fieldType.field].getMonth() + 1)).slice(-2) +
                                "-" +
                                ("0" + field[fieldType.field].getDate()).slice(-2);
                        } else if (field[fieldType.field] == "0000-00-00") {
                            field[fieldType.field] = null;
                        }
                        delete field[fieldType.field + "_time"];
                        break;
                    case TYPE_DATETIME:
                    case TYPE_TIMESTAMP:
                        if (
                            typeof field[fieldType.field] == "object" &&
                            field[fieldType.field] != "0000-00-00 00:00:00" &&
                            field[fieldType.field] != null
                        ) {
                            field[fieldType.field] =
                                field[fieldType.field].getFullYear() +
                                "-" +
                                ("0" + (field[fieldType.field].getMonth() + 1)).slice(-2) +
                                "-" +
                                ("0" + field[fieldType.field].getDate()).slice(-2) +
                                " " +
                                field[fieldType.field].getHours() +
                                ":" +
                                field[fieldType.field].getMinutes() +
                                ":" +
                                field[fieldType.field].getSeconds();
                        } else if (field[fieldType.field] == "0000-00-00 00:00:00") {
                            field[fieldType.field] = null;
                        }
                        delete field[fieldType.field + "_time"];
                        break;
                }
            }
        }
    } else {
        for (var fieldName in field) {
            var fieldType = typeof field[fieldName];
            if (fieldType != "undefined") {
                // DATE / DATETIME
                if (field[fieldName] instanceof Date && !isNaN(field[fieldName].valueOf())) {
                    field[fieldName] =
                        field[fieldName].getFullYear() +
                        "-" +
                        ("0" + (field[fieldName].getMonth() + 1)).slice(-2) +
                        "-" +
                        ("0" + field[fieldName].getDate()).slice(-2) +
                        " " +
                        field[fieldName].getHours() +
                        ":" +
                        field[fieldName].getMinutes() +
                        ":" +
                        field[fieldName].getSeconds();
                }
                delete field[fieldName + "_time"];
            }
        }
    }
}

function convertTypesOut(field, key) {
    // numeric
    /**
     * int TINYINT, SMALLINT, MEDIUMINT, INT, BIGINT, BIT data types.
     */
    const TYPE_INTEGER = 1;
    /**
     * int FLOAT, REAL, DOUBLE data types.
     */
    const TYPE_FLOAT = 2;
    /**
     * int DECIMAL, NUMERIC data types.
     */
    const TYPE_DECIMAL = 3;
    // date and time
    /**
     * int DATE data type.
     */
    const TYPE_DATE = 4;
    /**
     * int TIME data type.
     */
    const TYPE_TIME = 5;
    /**
     * int DATETIME data type.
     */
    const TYPE_DATETIME = 6;
    /**
     * int TIMESTAMP data type.
     */
    const TYPE_TIMESTAMP = 7;
    /**
     * int YEAR data type.
     */
    const TYPE_YEAR = 8;
    // string
    /**
     * int CHAR, VARCHAR data types.
     */
    const TYPE_VARCHAR = 9;
    /**
     * int TINYTEXT, SMALLTEXT, MEDIUMTEXT, TEXT, LONGTEXT data types.
     */
    const TYPE_TEXT = 10;
    /**
     * int ENUM data type.
     */
    const TYPE_ENUM = 11;
    /**
     * int SET data type.
     */
    const TYPE_SET = 12;
    // binary
    /**
     * int TINYBLOB, SMALLBLOB, MEDIUMBLOB, BLOB, LONGBLOB data types.
     */
    const TYPE_BLOB = 13;

    var ua = navigator.userAgent.toLowerCase();
    //alert(ua.indexOf('Firefox'));
    //console.log(field);
    //console.log(typeof field );
    if (
        typeof field != "undefined" &&
        field != null &&
        field.hasOwnProperty("__types__") &&
        typeof field.__types__ != "undefined"
    ) {
        for (var fieldTypeIdx in field.__types__) {
            var fieldType = field.__types__[fieldTypeIdx];
            if (typeof field[fieldType.field] != "undefined" && field[fieldType.field] != null) {
                switch (parseInt(fieldType.type)) {
                    case TYPE_SET:
                        if (field[fieldType.field] == null) field[fieldType.field] = [];
                        break;
                    case TYPE_INTEGER:
                        field[fieldType.field] = parseInt(field[fieldType.field]);
                        break;
                    case TYPE_FLOAT:
                    case TYPE_DECIMAL:
                        field[fieldType.field] = parseFloat(field[fieldType.field]);
                        break;
                    case TYPE_DATE:
                        if (field[fieldType.field] && typeof field[fieldType.field] == "string") {
                            if (field[fieldType.field] == "0000-00-00") {
                                field[fieldType.field] = null;
                            } else {
                                if (
                                    ua.indexOf("Firefox") == -1 ||
                                    (ua.indexOf("safari") != -1 && !(ua.indexOf("chrome") > -1))
                                ) {
                                    var dateTime = field[fieldType.field].split(" ").join("T");
                                    field[fieldType.field] = new Date(dateTime + 'T00:00:00' + defaultTimeZone.replace("Z", ""));
                                } else {
                                    field[fieldType.field] = new Date(moment(field[fieldType.field] + defaultTimeZone));
                                }
                            }
                        }
                        break;
                    case TYPE_DATETIME:
                    case TYPE_TIMESTAMP:
                        if (field[fieldType.field] && typeof field[fieldType.field] == "string") {
                            if (field[fieldType.field] == "0000-00-00 00:00:00") {
                                field[fieldType.field] = null;
                            } else {
                                field[fieldType.field + "_time"] = field[fieldType.field].split(" ")[1];
                                if (typeof field[fieldType.field + "TZ"] != "undefined") {
                                    if (
                                        ua.indexOf("Firefox") == -1 ||
                                        (ua.indexOf("safari") != -1 && !(ua.indexOf("chrome") > -1))
                                    ) {
                                        var dateTime = field[fieldType.field].split(" ").join("T");
                                        field[fieldType.field] = new Date(
                                            dateTime + field[fieldType.field + "TZ"].replace("Z", "")
                                        );
                                    } else {
                                        field[fieldType.field] = new Date(
                                            moment(field[fieldType.field] + field[fieldType.field + "TZ"])
                                        );
                                    }
                                } else {
                                    if (
                                        ua.indexOf("Firefox") == -1 ||
                                        (ua.indexOf("safari") != -1 && !(ua.indexOf("chrome") > -1))
                                    ) {
                                        var dateTime = field[fieldType.field].split(" ").join("T");
                                        field[fieldType.field] = new Date(dateTime + defaultTimeZone.replace("Z", ""));
                                    } else {
                                        field[fieldType.field] = new Date(
                                            moment(field[fieldType.field] + defaultTimeZone)
                                        );
                                    }
                                }
                            }
                        }
                        break;
                }
            }
        }
    } else if (typeof field == "object") {
        for (var fieldName in field) {
            var fieldType = typeof field[fieldName];
            if (fieldType != "undefined" && fieldType == "string" && field[fieldName] && field[fieldName] != null) {
                //console.log(1);
                // DATE / DATETIME
                var isDate = field[fieldName].match(/\d{4}\-\d{2}\-\d{2}/);
                var isDateTime = field[fieldName].match(/\d{4}\-\d{2}\-\d{2}\s\d{2}:\d{2}:\d{2}/);
                var isNumber = !isNaN(field[fieldName]);
                var isFloat = isNumber && field[fieldName].match(/\./);
                //console.log(isDate);
                //console.log(isDateTime);
                if (isDateTime != null && isDateTime.length > 0) {
                    field[fieldName + "_time"] = field[fieldName].split(" ")[1];
                    field[fieldName] = new Date(moment(field[fieldName] + defaultTimeZone));
                } else if (isDate != null && isDate.length > 0) {
                    field[fieldName] = new Date(moment(field[fieldName] + " 00:00:00" + defaultTimeZone));
                } else if (isFloat) {
                    field[fieldName] = parseFloat(field[fieldName]);
                } else if (isNumber) {
                    field[fieldName] = parseInt(field[fieldName]);
                }
            }
        }
    }
}

function array_walk_recursive(array, funcname, userdata) {
    //  discuss at: http://phpjs.org/functions/array_walk_recursive/
    // original by: Johnny Mast (http://www.phpvrouwen.nl)
    //   example 1: array_walk_recursive ({'a': 'b', 'c': {'d': 'e'}}, 'void', 'userdata');
    //   returns 1: true
    //   example 2: array_walk_recursive ('a', 'void', 'userdata');
    //   returns 2: false

    var key;

    if (typeof array !== "object" || array == null) {
        return false;
    }

    if (array.hasOwnProperty("__class__") && typeof array.__class__ != "undefined") {
        if (typeof userdata !== "undefined") {
            if (array.hasOwnProperty("$$hashKey")) {
                delete array["$$hashKey"];
            }
            eval(funcname + "( array, key , userdata  )");
        } else {
            eval(funcname + "(  userdata ) ");
        }
    } else {
        for (key in array) {
            if (typeof array[key] === "object") {
                array_walk_recursive(array[key], funcname, userdata);
            } else {
                //console.log(key);
                if (key == "$$hashKey") {
                    delete array[key];
                }

                if (typeof userdata !== "undefined") {
                    eval(funcname + "( array [key] , key , userdata  )");
                } else {
                    eval(funcname + "(  userdata ) ");
                }
            }
        }
    }

    return true;
}

function range(start, stop) {
    var result = [];
    for (var idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
        result.push(String.fromCharCode(idx));
    }
    return result;
}

function isInt(value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
}

// functions to validade form
validateForm = {
    /*onBlur: function(callBack, params)
	{
		if (typeof callBack != 'undefined' && callBack)
		{
			eval("validateForm."+callBack+"(params);");
		}
	},*/
    validateCPF: function(inputCPF) {
        const cpf = inputCPF.replace(/[^\d]+/g, "");

        if (!cpf) {
            return false;
        }

        // Elimina CPF's invalidos conhecidos
        if (
            cpf.length !== 11 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999"
        ) {
            return false;
        }

        // Valida 1o digito
        let add = 0;

        for (let i = 0; i < 9; i += 1) {
            add += parseInt(cpf.charAt(i), 10) * (10 - i);
        }

        let rev = 11 - (add % 11);

        if (rev === 10 || rev === 11) {
            rev = 0;
        }

        if (rev !== parseInt(cpf.charAt(9), 10)) return false;

        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i += 1) {
            add += parseInt(cpf.charAt(i), 10) * (11 - i);
        }

        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) {
            rev = 0;
        }

        if (rev !== parseInt(cpf.charAt(10), 10)) return false;

        return true;
    },
    initTimeField: function(model, field) {
        if (typeof model != "undefined" && typeof model[field] == "object") {
            //		model[field+'_time'] = model[field].toLocaleTimeString();
        }
    },
    updateTimeField: function(evt, model, field) {
        // 	alert(model);
        // 	console.log(evt);
        if (typeof evt != "undefined") {
            var hour = evt.split(":")[0];
            var minute = evt.split(":")[1];
            if (hour) {
                model[field].setHours(hour);
                if (minute) {
                    model[field].setMinutes(minute);
                }
                model[field].setSeconds(0);
            }
            //model[field].setSeconds(evt.split(':')[2]);
        }
        //   	console.log(model[field]);
    },
    hideField: function(hideCond, model, field) {
        if (typeof hideCond != "undefined" && hideCond && model != null) {
            for (var index in hideCond) {
                if (typeof model != "undefined" && typeof model == "object" && model.hasOwnProperty(index)) {
                    var value = model[index];
                    // para array
                    if (Array.isArray(hideCond[index])) {
                        if (hideCond[index].indexOf(value) >= 0) {
                            return true;
                        }
                    }
                    // valor
                    else {
                        if (value == hideCond[index]) {
                            return true;
                        }
                    }
                } else {
                    return true;
                }
            }
        }

        return false;
    },
    openDatepicker: function(field) {
        field.opened = true;
    },
    checkDateGreaterThanToday: function(date) {
        var splited = date.split("/");
        var varDate = new Date(splited[2], splited[1] - 1, splited[0]);
        var today = new Date(
            moment()
                .subtract(5, "years")
                .year(),
            11,
            31
        );

        if (varDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0)) {
            return false;
        } else {
            return true;
        }
    },
};

// utility functions
var default_cmp = function(a, b) {
        if (a == b) return 0;
        return a < b ? -1 : 1;
    },
    getCmpFunc = function(primer, reverse) {
        var dfc = default_cmp, // closer in scope
            cmp = default_cmp;
        if (primer) {
            cmp = function(a, b) {
                return dfc(primer(a), primer(b));
            };
        }
        if (reverse) {
            return function(a, b) {
                return -1 * cmp(a, b);
            };
        }
        return cmp;
    };

// actual implementation
sort_by = function() {
    var fields = [],
        n_fields = arguments.length,
        field,
        name,
        reverse,
        cmp;

    // preprocess sorting options
    for (var i = 0; i < n_fields; i++) {
        field = arguments[i];
        if (typeof field === "string") {
            name = field;
            cmp = default_cmp;
        } else {
            name = field.name;
            cmp = getCmpFunc(field.primer, field.reverse);
        }
        fields.push({
            name: name,
            cmp: cmp,
        });
    }

    // final comparison function
    return function(A, B) {
        var a, b, name, result;
        for (var i = 0; i < n_fields; i++) {
            result = 0;
            field = fields[i];
            name = field.name;

            result = field.cmp(A[name], B[name]);
            if (result !== 0) break;
        }
        return result;
    };
};


function removeAccents(value) {
	if (typeof value != 'undefined')
    return value
        .replace(/á/g, 'a')            
        .replace(/é/g, 'e')
        .replace(/í/g, 'i')
        .replace(/ó/g, 'o')
        .replace(/ú/g, 'u')
        .replace(/à/g, 'a')            
        .replace(/è/g, 'e')
        .replace(/ì/g, 'i')
        .replace(/ò/g, 'o')
        .replace(/ù/g, 'u')
        .replace(/â/g, 'a')            
        .replace(/ê/g, 'e')
        .replace(/î/g, 'i')
        .replace(/ô/g, 'o')
        .replace(/û/g, 'u')
        .replace(/Á/g, 'A')            
        .replace(/É/g, 'E')
        .replace(/Í/g, 'I')
        .replace(/Ó/g, 'O')
        .replace(/Ú/g, 'U')
        .replace(/À/g, 'A')            
        .replace(/È/g, 'E')
        .replace(/Ì/g, 'I')
        .replace(/Ò/g, 'O')
        .replace(/Ù/g, 'U')
        .replace(/Â/g, 'A')            
        .replace(/Ê/g, 'E')
        .replace(/Î/g, 'I')
        .replace(/Ô/g, 'O')
        .replace(/Û/g, 'U');
}
window.removeAccents = removeAccents;

function basename(path, suffix) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: Ash Searle (http://hexmen.com/blog/)
    // +   improved by: Lincoln Ramsay
    // +   improved by: djmix
    // *     example 1: basename('/www/site/home.htm', '.htm');
    // *     returns 1: 'home'
    // *     example 2: basename('ecra.php?p=1');
    // *     returns 2: 'ecra.php?p=1'
    var b = path.replace(/^.*[\/\\]/g, "");

    if (typeof suffix == "string" && b.substr(b.length - suffix.length) == suffix) {
        b = b.substr(0, b.length - suffix.length);
    }

    return b;
}

hashCode = function(s) {
    if (typeof s != 'undefined' && s)
    {
        return s.split("").reduce(function(a, b) {
            a = (a << 5) - a + b.charCodeAt(0);
            return a & a;
        }, 0);
    }
    else
    {
        return '000';
    }
};


function validateEmail(email, useApi = false) {
    if (useApi)
    {
        var service = Util.service('WSUtil', false);

        console.log(service);

        var result =  service.validateEmail(email);
        //UtilUi.alert("Cadastro para contato realizado com sucesso!", 'success');
        //alert('chamou!');
        console.log(result);
        if (result.valid)
        {
            return true;
        }
        else
        {
            UtilUi.alert({ title: 'E-mail inválido', message: result.error }, 'error');
        }
    }
    else
    {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}
window.validateEmail = validateEmail;


function validateMobilePhone(telefone) {
    /*
    // 1. Sanitizar: remover espaços, parênteses, hífen, etc.
    telefone = telefone.replace(/\D/g, '').trim();
    
    // 2. Verificar tamanho (11 dígitos: 2 para DDD + 9 para número)
    if (telefone.length !== 11) {
        return { valido: false, erro: 'Número deve ter 11 dígitos (DDD + 9 + 8 dígitos)' };
    }

    // 3. Verificar se começa com 9 (celular)
    if (telefone[2] !== '9') {
        return { valido: false, erro: 'Número de celular deve começar com 9 após o DDD' };
    }

    // 4. Validar DDD
    const ddd = telefone.slice(0, 2);
    const dddsValidos = [
        '11', '12', '13', '14', '15', '16', '17', '18', '19', // SP
        '21', '22', '24', '27', '28', // RJ e ES
        '31', '32', '33', '34', '35', '37', '38', // MG
        '41', '42', '43', '44', '45', '46', // PR
        '47', '48', '49', // SC
        '51', '53', '54', '55', // RS
        '61', // DF e entorno
        '62', '63', '64', '65', '66', '67', '68', '69', // Centro-Oeste
        '71', '73', '74', '75', '77', '79', // BA e SE
        '81', '82', '83', '84', '85', '86', '87', '88', '89', // NE
        '91', '92', '93', '94', '95', '96', '97', '98', '99' // Norte
    ];
    if (!dddsValidos.includes(ddd)) {
        return { valido: false, erro: 'DDD inválido para o Brasil' };
    }

    // 5. Bloquear sequências repetidas ou padrões inválidos
    const numero = telefone.slice(2); // Parte após o DDD
    // Bloquear números iguais (ex.: 99999-9999)
    if (/^(\d)\1{8}$/.test(numero)) {
        return { valido: false, erro: 'Número com dígitos repetidos não permitido' };
    }
    // Bloquear sequências crescentes/decrescentes (ex.: 12345-6789)
    if (/^123456789|987654321$/.test(numero)) {
        return { valido: false, erro: 'Sequências numéricas não permitidas' };
    }

    // 6. Validar formato final (formatar para exibição)
    const telefoneFormatado = `(${ddd}) 9${numero.slice(1, 5)}-${numero.slice(5)}`;
    return { valido: true, erro: '', formatado: telefoneFormatado };
    */

    var service = Util.service('WSUtil', false);

    console.log(service);

    var result =  service.validateMobilePhone(telefone);
    //alert('chamou!');
    console.log(result);
    if (result.valid)
    {
        return true;
    }
    else
    {
        UtilUi.alert({ title: 'Telefone inválido', message: result.error }, 'error');
    }
}

window.validateMobilePhone = validateMobilePhone;

window.initMap = function()
{
    const event = new Event('mapLoaded');
    console.log('initMap');
    setTimeout(function()
    {
        window.dispatchEvent(event);
    }
    ,1000);
    

};

State = {
    getCitys: (UF, callback) => {
        if(!UF) {
            return false;
        }

        fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios`, {'method': 'GET'})
            .then(respObject => {
                return respObject.json();
            })
            .then(response => {
                callback(response)
            })
            .catch(error => console.error(error));
    },
    getUFByState: state => {
        if(!state) {
            return false;
        }

        for(let UF in State.statesUFList) {
            if(State.statesUFList[UF] == state) {
                return UF;
            } 
        }

        return false;
    },
    getStateByUF: uf => {
        if(!uf) {
            return false;
        }
        
        for(let UF in State.statesUFList) {
            if(UF == uf) {
                return State.statesUFList[UF];
            } 
        }
        
        return null;
    },
    statesUFList: {
        "AC": "Acre",
        "AL": "Alagoas",
        "AP": "Amapá",
        "AM": "Amapá",
        "BA": "Bahia",
        "CE": "Ceará",
        "DF": "Distrito Federal",
        "ES": "Espirito Santo",
        "GO": "Goiás",
        "MA": "Maranhão",
        "MS": "Mato Grosso do Sul",
        "MT": "Mato Grosso",
        "MG": "Minas Gerais",
        "PA": "Pará",
        "PB": "Paraíba",
        "PR": "Paraná",
        "PE": "Pernambuco",
        "PI": "Piauí",
        "RJ": "Rio de Janeiro",
        "RS": "Rio Grande do Sul",
        "RO": "Rondônia",
        "RR": "Roraima",
        "SC": "Santa Catarina",
        "SP": "São Paulo",
        "SE": "Sergipe",
        "TO": "Tocantins",
    },
    states: [
        { label: 'Acre', value: 'Acre' },
        { label: 'Alagoas', value: 'Alagoas' },
        { label: 'Amapá', value: 'Amapá' },
        { label: 'Amazonas', value: 'Amazonas' },
        { label: 'Bahia', value: 'Bahia' },
        { label: 'Ceará', value: 'Ceará' },
        { label: 'Distrito Federal', value: 'Distrito Federal' },
        { label: 'Espirito Santo', value: 'Espirito Santo' },
        { label: 'Goiás', value: 'Goiás' },
        { label: 'Maranhão', value: 'Maranhão' },
        { label: 'Mato Grosso do Sul', value: 'Mato Grosso do Sul' },
        { label: 'Mato Grosso', value: 'Mato Grosso' },
        { label: 'Minas Gerais', value: 'Minas Gerais' },
        { label: 'Pará', value: 'Pará' },
        { label: 'Paraíba', value: 'Paraíba' },
        { label: 'Paraná', value: 'Paraná' },
        { label: 'Pernambuco', value: 'Pernambuco' },
        { label: 'Piauí', value: 'Piauí' },
        { label: 'Rio de Janeiro', value: 'Rio de Janeiro' },
        { label: 'Rio Grande do Norte', value: 'Rio Grande do Norte' },
        { label: 'Rio Grande do Sul', value: 'Rio Grande do Sul' },
        { label: 'Rondônia', value: 'Rondônia' },
        { label: 'Roraima', value: 'Roraima' },
        { label: 'Santa Catarina', value: 'Santa Catarina' },
        { label: 'São Paulo', value: 'São Paulo' },
        { label: 'Sergipe', value: 'Sergipe' },
        { label: 'Tocantins', value: 'Tocantins' }
    ],
}